/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdStepperProps } from './type';
const props: TdStepperProps = {
  /** 禁用输入框 */
  disableInput: {
    type: Boolean,
    value: false,
  },
  /** 禁用全部操作 */
  disabled: {
    type: null,
    value: undefined,
  },
  /** 输入框宽度，默认单位 `px` */
  inputWidth: {
    type: Number,
  },
  /** 是否整型 */
  integer: {
    type: Boolean,
    value: true,
  },
  /** 最大值 */
  max: {
    type: Number,
    value: 100,
  },
  /** 最小值 */
  min: {
    type: Number,
    value: 0,
  },
  /** 组件尺寸 */
  size: {
    type: String,
    value: 'medium',
  },
  /** 步长 */
  step: {
    type: Number,
    value: 1,
  },
  /** 组件风格 */
  theme: {
    type: String,
    value: 'normal',
  },
  /** 值 */
  value: {
    type: null,
    value: null,
  },
  /** 值，非受控属性 */
  defaultValue: {
    type: null,
    value: 0,
  },
};

export default props;
